'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCardFlip = require('react-card-flip');

var _reactCardFlip2 = _interopRequireDefault(_reactCardFlip);

var _styles = require('../../styles/styles');

var _styles2 = _interopRequireDefault(_styles);

var _Choices = require('./Choices');

var _Choices2 = _interopRequireDefault(_Choices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by sbardian on 5/18/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var QuestionWrapper = function (_React$Component) {
  _inherits(QuestionWrapper, _React$Component);

  function QuestionWrapper(props) {
    _classCallCheck(this, QuestionWrapper);

    var _this = _possibleConstructorReturn(this, (QuestionWrapper.__proto__ || Object.getPrototypeOf(QuestionWrapper)).call(this, props));

    _this.state = {
      isFlipped: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  // Flips the card on click to reveal the answer


  _createClass(QuestionWrapper, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.setState({ isFlipped: !this.state.isFlipped });
      if (this.props.answerButtonClicked) {
        this.props.answerButtonClicked(this.props.question.correct_answer);
      }
    }
  }, {
    key: 'htmlDecode',
    value: function htmlDecode(input) {
      var e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  }, {
    key: 'render',
    value: function render() {
      // TODO: pass click hanlder on answer button click...
      return _react2.default.createElement(
        'div',
        { style: _styles2.default.cardStyle },
        _react2.default.createElement(
          _reactCardFlip2.default,
          { isFlipped: this.state.isFlipped },
          _react2.default.createElement(
            'div',
            { key: 'front', style: _styles2.default.cardFront },
            _react2.default.createElement(
              'div',
              { style: _styles2.default.cardFrontTop },
              _react2.default.createElement(
                'h3',
                null,
                this.props.question.category
              ),
              _react2.default.createElement(
                'h4',
                null,
                this.htmlDecode(this.props.question.question)
              )
            ),
            _react2.default.createElement(_Choices2.default, {
              correct_answer: this.props.question.correct_answer,
              incorrect_answers: this.props.question.incorrect_answers,
              answerSelectedClicked: this.props.answerSelectedClicked,
              answerButtonClicked: this.props.answerButtonClicked
            }),
            _react2.default.createElement(
              'div',
              { style: _styles2.default.btnContainer },
              _react2.default.createElement(
                'button',
                { style: _styles2.default.frontBtn, onClick: this.handleClick },
                'Answer'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { key: 'back', style: _styles2.default.cardBack },
            _react2.default.createElement(
              'div',
              { style: _styles2.default.cardBackTop },
              _react2.default.createElement(
                'h3',
                null,
                'Correct Answer:'
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              this.props.question.correct_answer
            ),
            _react2.default.createElement(
              'div',
              { style: _styles2.default.btnContainer },
              _react2.default.createElement(
                'button',
                { style: _styles2.default.backBtn, onClick: this.handleClick },
                'Back'
              )
            )
          )
        )
      );
    }
  }]);

  return QuestionWrapper;
}(_react2.default.Component);

exports.default = QuestionWrapper;


QuestionWrapper.propTypes = {
  question: _propTypes2.default.object,
  answerSelectedClicked: _propTypes2.default.func,
  answerButtonClicked: _propTypes2.default.func
};

QuestionWrapper.defaultProps = {
  question: {},
  answerSelectedClicked: null,
  answerButtonClicked: null
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /Users/sbardian/WebstormProjects/Reactjs/opentrivia-react/lib/components/QuestionWrapper.js
// module id = 168
// module chunks = 0